import axios from 'axios'
import { NotificationTemplatesModalType } from '@/modules/configurationModule/detail/notifications/components/notification-templates-modal/notification-templates-modal.model'

class CustomNotificationTypeService {
    async getCustomNotificationTypes(): Promise<NotificationTemplatesModalType[]> {
        const response = await axios.get<NotificationTemplatesModalType[]>('/configuration/customNotificationTypes')
        return response.data
    }
}
export const customNotificationTypeService = new CustomNotificationTypeService()
